export const PREVIEW = 'preview';
export const PROPERTIES_PANEL = 'properties-panel';
export const TIMELINE = 'timeline';
export const TIMELINE_TOOLBAR = 'timeline-toolbar';
